import {
	GET_FORM,
} from 'actions/forms';

const INITIAL_STATE = {
	currentForm: null,
	loading: false,
	error: null,
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_FORM:
			return {
				...state,
				currentForm: action.payload,
				loading: false,
				error: null
			};

		default:
			return state;
	}
}